/**
 * Created by swandelow on 02/11/17.
 */
angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:oid/rate", {
        templateUrl: 'templates/rate/rate.html',
        controller: 'RateController',
        title: 'rate.TITLE',
        sidebar: 'priceAndAvailability'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/rate/rate.route.js
// module id = 823
// module chunks = 3